import { render, staticRenderFns } from "./KeywordsSection.vue?vue&type=template&id=ab9cac5a&scoped=true&"
import script from "./KeywordsSection.vue?vue&type=script&lang=js&"
export * from "./KeywordsSection.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsSection.vue?vue&type=style&index=0&id=ab9cac5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9cac5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VChip,VFlex,VIcon,VLayout,VSnackbar,VTextField})
